<template>
<div>
  <el-dialog title="" v-model="modalShow" size="tiny" custom-class="cant-book-modal" @close="modalClose">
    <div class="share-body">
      <div class="sorry-left">
        <div class="sorry-txt">请用微信扫描右侧二维码</div>
        <div class="sorry-txt important">使用【办签助手】小程序修改赴馆时间</div>
        <div class="sorry-txt">上上签暂不支持修改</div>
        <img class="sorry-img" src="../../assets/imgs/sorry.png">
      </div>

      <div class="share-code">
        <div class="share-code-img" :style="'background-image:url('+wxCodeUrl+')'"></div>
      </div>
      <div class="code-txt" v-if="env" style="top:auto;bottom:30px;color:red;width:auto;left:80px">(测试、开发环境中二维码无效，仅为展示)</div>
      <div class="code-txt">『办签助手』小程序</div>
    </div>
  </el-dialog>
</div>
</template>

<script>
import { env } from '../../libs/env';
import wxUtils from '../../libs/wx-utils';

export default {
  props: ['cantViewShow', 'user_order_id', 'peer_account_id'],
  data() {
    return {
      env,
      wxCodeUrl: '',
    };
  },
  computed: {
    modalShow() {
      return this.cantViewShow;
    },
  },

  watch: {
    peer_account_id(val) {
      if (val) {
        this.peer_account_id = val;
        wxUtils.getOrderDetailWxaCode(this.user_order_id, this.peer_account_id).then((data) => {
          this.wxCodeUrl = data;
        }).catch((e) => {
          if (e) console.log(e);
        });
      }
    },
  },

  methods: {
    modalClose() {
      this.$emit('input', false);
    },
  },

  created() {

  },
  mounted() {
    wxUtils.getOrderDetailWxaCode(this.user_order_id, this.peer_account_id).then((data) => {
      this.wxCodeUrl = data;
    }).catch((e) => {
      if (e) console.log(e);
    });
  },
};
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// src/components/order-detail/cant-view-order-detail-modal.vue